import { render, staticRenderFns } from "./PinCommentModal.vue?vue&type=template&id=af484c80&"
import script from "./PinCommentModal.vue?vue&type=script&lang=js&"
export * from "./PinCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af484c80')) {
      api.createRecord('af484c80', component.options)
    } else {
      api.reload('af484c80', component.options)
    }
    module.hot.accept("./PinCommentModal.vue?vue&type=template&id=af484c80&", function () {
      api.rerender('af484c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/PinsAnnotations/PinCommentModal.vue"
export default component.exports